import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  z-index: 9;
  top: 0;
  left: -68;
  transform: scale(1.2) translateX(-203px) translateY(-124px);
`;

export const ContentContainer = styled.div`
  position: absolute;
  top: 338;
  left: 1128;
  width: 360;
  height: 360;
  transform: scale(0.8);
`;

export const StaticAssetsContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`;

export const PortalButton = styled.button`
  position: absolute;
  top: 374;
  left: 1165;
  width: 288;
  height: 288;
  border: none;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 55;
  left: 55;
  border-radius: 50%;
  overflow: hidden;
`;

export const FadeContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`;
